import type { MetaFunction } from "react-router";
import { NotFoundError } from "@repo/ui/components/not-found-error";

export const meta: MetaFunction = () => {
  return [
    { title: "Propane" },
    { name: "description", content: "Propane" },
    { name: "robots", content: "noindex" },
  ];
};

export default function Index() {
  return (
    <div className="flex h-dvh w-full items-center justify-center">
      <NotFoundError message="Page not found" />
    </div>
  );
}
